import * as z from "zod";

export const getOdooIntegration = {
  name: "getOdooIntegration" as const,
  input: z.object({}),
  output: z.object({
    integration: z
      .object({
        url: z.string(),
        database: z.string(),
        username: z.string(),
        apiKeyPreview: z.string(),
        version: z.union([z.literal(16), z.literal(17)]),
        autoPostCreditNotes: z.boolean(),
        creditNoteJournalId: z.number().nullable(),
        partialReturnCorrectionConceptId: z.number().nullable(),
      })
      .nullable(),
  }),
};
